import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import type { BrandingContextView } from '../../domain/branding-context'
import { resolveBrandingContext } from '../../infrastructure/branding-context.resolver'
import { getPublishedTenantAppearance } from '../../infrastructure/tenant-appearance.gateway'

export const useBrandingContextStore = defineStore('branding-context', () => {
  const context = shallowRef<BrandingContextView | null>(null)
  const resolved = shallowRef(false)
  let pending: Promise<BrandingContextView> | null = null

  async function resolve() {
    if (resolved.value && context.value) return context.value
    if (pending) return pending
    pending = (async () => {
      const base = resolveBrandingContext()
      try {
        const appearance = await getPublishedTenantAppearance()
        context.value = { ...base, appearance: appearance.config, appearanceVersion: appearance.version }
      } catch {
        context.value = base
      }
      resolved.value = true
      return context.value
    })()
    try {
      return await pending
    } finally {
      pending = null
    }
  }

  function acceptPublishedAppearance(appearance: import('../../domain/tenant-appearance').TenantAppearanceDocument, version: number) {
    context.value = { ...(context.value ?? resolveBrandingContext()), appearance, appearanceVersion: version }
    resolved.value = true
  }

  return { context, resolved, resolve, acceptPublishedAppearance }
})
